// src/services/AuthService.js
import api from './api';

const LoginUser = async (serviceNo, password) => {
  const resp = await api.post(
    `Login/UserLogin?serviceNo=${serviceNo}&password=${password}`
  );

  if (resp.data.StatusCode === 200 && resp.data.AuthKey) {
    const key = resp.data.AuthKey;
    localStorage.setItem('authKey', key);
    api.defaults.headers.common['auth-key'] = key;
  }
  return resp;
};

const LogoutUser = async () => {
  await api.post('Login/LogoutUser');
  localStorage.removeItem('authKey');
  delete api.defaults.headers.common['auth-key'];
};

const PostUserDetails = async (userData) => {
  return api.post('UserRegister/PostUserDetails', [userData]);
};

const GetUserDetailsByUser = async (serviceNo) => {
  return api.get(`UserDetails/GetUserDetailsByUser?sno=${serviceNo}`);
};

/* ---------- NEW: Booking ---------- */
const PostBookingDetails = async (bookingData) => {
  // `bookingData` should be an **object** (or array if backend expects it)
  return api.post('BookingRegister/PostBookingDetails', bookingData);
};

export default {
  LoginUser,
  LogoutUser,
  PostUserDetails,
  GetUserDetailsByUser,
  PostBookingDetails,
};


// import axios from "axios";

// const LoginUser = async (serviceNo, password) => {
//   let config = {
//     method: "post",
//     url: `Login/UserLogin?serviceNo=${serviceNo}&password=${password}`,
//   };
//   return axios.request(config).then((response) => {
//     // Set auth-key header immediately after successful login
//     if (response.data.StatusCode === 200 && response.data.AuthKey) {
//       axios.defaults.headers.common["auth-key"] = response.data.AuthKey;
//     }
//     return response;
//   });
// };

// const LogoutUser = async () => {
//   let config = {
//     method: "post",
//     url: "Login/LogoutUser",
//   };
//   return axios.request(config).then((response) => {
//     return response;
//   });
// };

// const PostUserDetails = async (userData) => {
//   let config = {
//     method: "post",
//     url: "UserRegister/PostUserDetails",
//     data: [userData],
//   };
//   return axios.request(config).then((response) => {
//     return response;
//   });
// };

// const GetUserDetailsByUser = async (serviceNo) => {
//   let config = {
//     method: "get",
//     url: `UserDetails/GetUserDetailsByUser?sno=${serviceNo}`,
//   };
//   return axios.request(config).then((response) => {
//     return response;
//   });
// };

// export default {
//   LoginUser,
//   LogoutUser,
//   PostUserDetails,
//   GetUserDetailsByUser,
// };
